"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobi_template_model_1 = require("@projektionisten/mobi-template-model");
var rxjs_1 = require("rxjs");
var util_1 = require("util");
var mobi_template_model_2 = require("@projektionisten/mobi-template-model");
var URL = 'https://tourism.opendatahub.bz.it/api';
var StaOpenDataHubInformationInterface = /** @class */ (function () {
    function StaOpenDataHubInformationInterface(appSettings, apiToAppMatcher, http, language, referer) {
        this.appSettings = appSettings;
        this.apiToAppMatcher = apiToAppMatcher;
        this.http = http;
        this.referer = referer;
        this.poiList = [];
        this.HTTPCONSTANTS = {
            OK: 200,
            NOT_MODIFIED: 304
        };
        this.POI_ENPOINT_TYPES = {
            ACCOMMODATION: 1,
            POI: 2,
            ODHACTIVITYPOI: 3
        };
    }
    /**
     * get reduced opendatahub pois for each Poi Type after app start
     */
    StaOpenDataHubInformationInterface.prototype.prefetchPOIList = function (params) {
        var _this = this;
        return new rxjs_1.Observable(function (mainObserver) {
            // Enpoints for each POI TYPE
            var endPointAccommodation = '/STA/Accommodation';
            var endPointODHActivityPoi = '/STA/ODHActivityPoi';
            var processedParams = {
                language: _this.getLanguageString(params.language),
                referer: _this.referer
            };
            var individualResults = [];
            var AccommodationResults = new rxjs_1.Observable(function (observer) {
                var accommodationParams = __assign(__assign({}, processedParams), { fields: "Id,AccoDetail." + processedParams.language + ".Name,AccoDetail." + processedParams.language + ".City", pagesize: 10000 });
                _this.performRequest(endPointAccommodation, accommodationParams).subscribe({
                    next: function (response) {
                        var _a;
                        if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                            observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                        }
                        var data = (_a = response.body) === null || _a === void 0 ? void 0 : _a.Items;
                        if (data === undefined || data === null) {
                            observer.next();
                            observer.complete();
                        }
                        var newdata = data.map(function (obj) { return ({
                            Id: obj.Id,
                            Name: obj['AccoDetail.' + processedParams.language + '.Name'],
                            City: obj['AccoDetail.' + processedParams.language + '.City'],
                            type: _this.POI_ENPOINT_TYPES.ACCOMMODATION
                        }); });
                        observer.next(newdata);
                        observer.complete();
                    },
                    error: function (error) {
                        observer.error([{
                                code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                                value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                            }]);
                    }
                });
            });
            individualResults.push(AccommodationResults);
            var ODHActivityPoiResults = new rxjs_1.Observable(function (observer) {
                var activityParams = __assign(__assign({}, processedParams), { fields: "Id,Detail." + processedParams.language + ".Title,ContactInfos." + processedParams.language + ".City", pagesize: 20000 });
                _this.performRequest(endPointODHActivityPoi, activityParams).subscribe({
                    next: function (response) {
                        var _a;
                        if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                            observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                        }
                        var data = (_a = response.body) === null || _a === void 0 ? void 0 : _a.Items;
                        if (data === undefined || data === null) {
                            observer.next();
                            observer.complete();
                        }
                        var newdata = data.map(function (obj) { return ({
                            Id: obj.Id,
                            Name: obj['Detail.' + processedParams.language + '.Title'],
                            City: obj['ContactInfos.' + processedParams.language + '.City'],
                            type: _this.POI_ENPOINT_TYPES.ODHACTIVITYPOI
                        }); });
                        observer.next(newdata);
                        observer.complete();
                    },
                    error: function (error) {
                        observer.error([{
                                code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                                value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                            }]);
                    }
                });
            });
            individualResults.push(ODHActivityPoiResults);
            rxjs_1.forkJoin(individualResults).subscribe(function (response) {
                var resultArray = [];
                for (var _i = 0, response_1 = response; _i < response_1.length; _i++) {
                    var partialResponse = response_1[_i];
                    resultArray = resultArray.concat(partialResponse);
                }
                _this.poiList = resultArray;
                mainObserver.complete();
            }, function (error) {
                console.error('An error occurred:', error.error !== undefined ? error.error.message : error.message);
                mainObserver.error();
            });
        });
    };
    /**
     * traffic node finder for string input
     * filters the poiList by string input
     * @param params
     * @returns {Observable<TrafficNode[]>}
     */
    StaOpenDataHubInformationInterface.prototype.getTrafficNodesForStringInput = function (params) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            if (params.input !== undefined) {
                var listOfStops = [];
                var normalizedInput_1 = params.input.trim().toLowerCase();
                var trimmedInput_1 = params.input.trim();
                var data = _this.poiList.filter(function (point) {
                    var _a;
                    return ((_a = point.Name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedInput_1)) || point.Id === trimmedInput_1;
                });
                for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                    var point = data_1[_i];
                    var newNode = mobi_template_model_1.TrafficNode.factory({
                        id: point.Id,
                        name: point.Name,
                        type: mobi_template_model_1.TRAFFICNODE_TYPE.POI,
                        city: point.City,
                        metaData: { poitype: point.type }
                    });
                    listOfStops.push(newNode);
                }
                observer.next(listOfStops);
                observer.complete();
            }
            else {
                observer.next([]);
                observer.complete();
            }
        });
    };
    /**
     * get Location if node Location is null
     * used for getting Location for reduced nodes
     * @param params
     * @param node
     * @returns {Observable<TrafficNode>}
     */
    StaOpenDataHubInformationInterface.prototype.getLocationForPoi = function (params) {
        var _this = this;
        var processedParams = {
            language: params.language !== undefined ? this.getLanguageString(params.language) : 'it'
        };
        var endPoint;
        if (params.node.metaData.poitype === this.POI_ENPOINT_TYPES.POI) {
            endPoint = '/Poi/' + params.node.id;
            return new rxjs_1.Observable(function (observer) {
                _this.performRequest(endPoint, processedParams).subscribe({
                    next: function (response) {
                        // checks the HTTP Status Code
                        if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                            observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                        }
                        var data = response.body;
                        if (typeof data === 'string') {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (error) {
                                observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                            }
                        }
                        // return with empty array when no hits were found
                        if (data === undefined || data === null) {
                            observer.next();
                            observer.complete();
                        }
                        if (data.Id === params.node.id) {
                            // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                            var newNode = mobi_template_model_1.TrafficNode.factory({
                                id: data.Id,
                                name: data.Detail[processedParams.language].Title,
                                city: data.ContactInfos[processedParams.language].City,
                                type: params.node.type,
                                location: {
                                    latitude: data.GpsInfo[0].Latitude,
                                    longitude: data.GpsInfo[0].Longitude,
                                    projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                                },
                                distanceToReferenceNode: 0,
                                metaData: params.node.metaData
                            });
                            observer.next(newNode);
                            observer.complete();
                        }
                    },
                    error: function (error) {
                        observer.error([{
                                code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                                value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                            }]);
                    }
                });
            });
        }
        else if (params.node.metaData.poitype === this.POI_ENPOINT_TYPES.ACCOMMODATION) {
            endPoint = '/Accommodation/' + params.node.id;
            return new rxjs_1.Observable(function (observer) {
                _this.performRequest(endPoint, processedParams).subscribe({
                    next: function (response) {
                        // checks the HTTP Status Code
                        if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                            observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                        }
                        var data = response.body;
                        if (typeof data === 'string') {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (error) {
                                observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                            }
                        }
                        // return with empty array when no hits were found
                        if (data === undefined || data === null) {
                            observer.next();
                            observer.complete();
                        }
                        if (data.Id === params.node.id) {
                            // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                            var newNode = mobi_template_model_1.TrafficNode.factory({
                                id: data.Id,
                                name: data.AccoDetail[processedParams.language].Name,
                                city: data.AccoDetail[processedParams.language].City,
                                type: params.node.type,
                                location: {
                                    latitude: data.Latitude,
                                    longitude: data.Longitude,
                                    projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                                },
                                distanceToReferenceNode: 0,
                                metaData: params.node.metaData
                            });
                            observer.next(newNode);
                            observer.complete();
                        }
                    },
                    error: function (error) {
                        observer.error([{
                                code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                                value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                            }]);
                    }
                });
            });
        }
        else if (params.node.metaData.poitype === this.POI_ENPOINT_TYPES.ODHACTIVITYPOI) {
            endPoint = '/ODHActivityPoi/' + params.node.id;
            return new rxjs_1.Observable(function (observer) {
                _this.performRequest(endPoint, processedParams).subscribe({
                    next: function (response) {
                        // checks the HTTP Status Code
                        if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                            observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                        }
                        var data = response.body;
                        if (typeof data === 'string') {
                            try {
                                data = JSON.parse(data);
                            }
                            catch (error) {
                                observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                            }
                        }
                        if (data.length !== undefined && data.length > 0) {
                            data = data[0];
                        }
                        // return with empty array when no hits were found
                        if (data === undefined || data === null) {
                            observer.next();
                            observer.complete();
                        }
                        if (data.Id === params.node.id) {
                            // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                            var newNode = mobi_template_model_1.TrafficNode.factory({
                                id: data.Id,
                                name: data.Detail[processedParams.language].Title,
                                city: data.ContactInfos[processedParams.language].City,
                                type: params.node.type,
                                location: {
                                    latitude: data.GpsInfo[0].Latitude,
                                    longitude: data.GpsInfo[0].Longitude,
                                    projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                                },
                                distanceToReferenceNode: 0,
                                metaData: params.node.metaData
                            });
                            observer.next(newNode);
                            observer.complete();
                        }
                    },
                    error: function (error) {
                        observer.error([{
                                code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                                value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                            }]);
                    }
                });
            });
        }
        else {
            return new rxjs_1.Observable(function (observer) { return observer.error([{
                    code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                    value: 'unknown error'
                }]); });
        }
    };
    /**
     * get map nodes for map bounds
     * for each poi type
     * @param params
     * @returns {Observable<ContextAwareTrafficNode[]>}
     */
    StaOpenDataHubInformationInterface.prototype.getMapNodes = function (params) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            var individualResults = [];
            individualResults.push(_this.getMapNodesPois(params));
            individualResults.push(_this.getMapNodesAccommodation(params));
            individualResults.push(_this.getMapNodesODHActivity(params));
            rxjs_1.forkJoin(individualResults).subscribe(function (results) {
                var resultArray = [];
                for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
                    var partialResults = results_1[_i];
                    resultArray = resultArray.concat(partialResults);
                }
                observer.next(resultArray);
                observer.complete();
            }, function (error) {
                observer.error(error);
            });
        });
    };
    StaOpenDataHubInformationInterface.prototype.getMapNodesPois = function (params) {
        var _this = this;
        var processedParams = {
            pagesize: 80,
            language: params.language !== undefined ? this.getLanguageString(params.language) : 'it',
            latitude: params.center.latitude,
            longitude: params.center.longitude,
            radius: params.radius
        };
        var endpointUrlPoi = '/Poi';
        return new rxjs_1.Observable(function (observer) {
            _this.performRequest(endpointUrlPoi, processedParams).subscribe({
                next: function (response) {
                    if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                        observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                    }
                    var data = response.body;
                    if (data === undefined || data === null) {
                        observer.next();
                        observer.complete();
                    }
                    var listOfStops = [];
                    for (var _i = 0, _a = data.Items; _i < _a.length; _i++) {
                        var point = _a[_i];
                        // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                        var newNode = mobi_template_model_1.ContextAwareTrafficNode.factory({
                            id: point.Id,
                            name: point.Detail[processedParams.language].Title,
                            city: point.ContactInfos[processedParams.language].City,
                            type: mobi_template_model_1.TRAFFICNODE_TYPE.POI,
                            location: {
                                latitude: point.GpsInfo[0].Latitude,
                                longitude: point.GpsInfo[0].Longitude,
                                projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                            },
                            distanceToReferenceNode: undefined,
                            servicingMots: undefined
                        });
                        listOfStops.push(newNode);
                    }
                    observer.next(listOfStops);
                    observer.complete();
                },
                error: function (error) {
                    observer.error([{
                            code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                            value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                        }]);
                }
            });
        });
    };
    StaOpenDataHubInformationInterface.prototype.getMapNodesAccommodation = function (params) {
        var _this = this;
        var processedParams = {
            pagesize: 80,
            language: params.language !== undefined ? this.getLanguageString(params.language) : 'it',
            latitude: params.center.latitude,
            longitude: params.center.longitude,
            radius: params.radius
        };
        var endpointUrlAccomendations = '/Accommodation';
        return new rxjs_1.Observable(function (observer) {
            _this.performRequest(endpointUrlAccomendations, processedParams).subscribe({
                next: function (response) {
                    if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                        observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                    }
                    var data = response.body;
                    if (data === undefined || data === null) {
                        observer.next();
                        observer.complete();
                    }
                    var listOfStops = [];
                    for (var _i = 0, _a = data.Items; _i < _a.length; _i++) {
                        var point = _a[_i];
                        // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                        var newNode = mobi_template_model_1.ContextAwareTrafficNode.factory({
                            id: point.Id,
                            name: point.AccoDetail[processedParams.language].Name,
                            city: point.AccoDetail[processedParams.language].City,
                            type: mobi_template_model_1.TRAFFICNODE_TYPE.POI,
                            location: {
                                latitude: point.Latitude,
                                longitude: point.Longitude,
                                projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                            },
                            distanceToReferenceNode: undefined,
                            servicingMots: undefined
                        });
                        listOfStops.push(newNode);
                    }
                    observer.next(listOfStops);
                    observer.complete();
                },
                error: function (error) {
                    observer.error([{
                            code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                            value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                        }]);
                }
            });
        });
    };
    StaOpenDataHubInformationInterface.prototype.getMapNodesODHActivity = function (params) {
        var _this = this;
        var processedParams = {
            pagesize: 80,
            language: params.language !== undefined ? this.getLanguageString(params.language) : 'it',
            latitude: params.center.latitude,
            longitude: params.center.longitude,
            radius: params.radius
        };
        var endpointODHActivityPoi = '/ODHActivityPoi';
        return new rxjs_1.Observable(function (observer) {
            _this.performRequest(endpointODHActivityPoi, processedParams).subscribe({
                next: function (response) {
                    if (response.status.code !== _this.HTTPCONSTANTS.OK && response.status.code !== _this.HTTPCONSTANTS.NOT_MODIFIED) {
                        observer.error([{ code: 'ERROR_CODE.GENERAL_SERVER_ERROR', value: response.status.code }]);
                    }
                    var data = response.body;
                    if (data === undefined || data === null) {
                        observer.next();
                        observer.complete();
                    }
                    var listOfStops = [];
                    for (var _i = 0, _a = data.Items; _i < _a.length; _i++) {
                        var point = _a[_i];
                        // Neuen TrafficNode mit den oben zusammengestellten Informationen erzeugen
                        var newNode = mobi_template_model_1.ContextAwareTrafficNode.factory({
                            id: point.Id,
                            name: point.Detail[processedParams.language].Title,
                            city: util_1.isNullOrUndefined(point.ContactInfos[processedParams.language]) ? '' :
                                point.ContactInfos[processedParams.language].City,
                            type: mobi_template_model_1.TRAFFICNODE_TYPE.POI,
                            location: {
                                latitude: point.GpsInfo[0].Latitude,
                                longitude: point.GpsInfo[0].Longitude,
                                projection: mobi_template_model_1.MAP_PROJECTION.WGS84
                            },
                            distanceToReferenceNode: undefined,
                            servicingMots: undefined
                        });
                        listOfStops.push(newNode);
                    }
                    observer.next(listOfStops);
                    observer.complete();
                },
                error: function (error) {
                    observer.error([{
                            code: 'ERROR_CODE.GENERAL_SERVER_ERROR',
                            value: !util_1.isNullOrUndefined(error.message) ? error.message : ''
                        }]);
                }
            });
        });
    };
    /**
     * Performs the http request and extracts the json data from the response
     * @param input Either an object of type RequestSettings or just the url of the endpoint
     * @param data The JSON object of request parameters from the app
     * @returns {Observable<R>} Observable with JSON response payload
     */
    StaOpenDataHubInformationInterface.prototype.performRequest = function (endpoint, data) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.http.performHttpRequest(URL + endpoint, {
                method: mobi_template_model_1.HTTP_METHOD.GET,
                payload: data,
                responseType: mobi_template_model_1.RESPONSE_TYPE.JSON
            }).subscribe({
                next: function (response) {
                    observer.next(response);
                    observer.complete();
                },
                error: function (error) {
                    observer.error(error);
                }
            });
        });
    };
    StaOpenDataHubInformationInterface.prototype.getLanguageString = function (language) {
        switch (language) {
            case mobi_template_model_2.LANGUAGE.DE:
                return 'de';
            case mobi_template_model_2.LANGUAGE.EN:
                return 'en';
            case mobi_template_model_2.LANGUAGE.IT:
                return 'it';
            default:
                return 'it';
        }
    };
    return StaOpenDataHubInformationInterface;
}());
exports.StaOpenDataHubInformationInterface = StaOpenDataHubInformationInterface;
